import { ResetPassword } from '@online-webinar/account';
import { RouterType } from '@online-webinar/router/src/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/reset-password/$resetCode'].update({
        staticData: { title: { page: 'ResetPassword.PageHeading' } },
        component: ResetPassword
    });
};
